export const broker = {
  url: "wss://plan.nuttu.fi/ws",
  username: "daily-planner-viewer",
  password: "flotilla-heredity-armoire-cremate",
};
